import React, { useState } from "react";
import gift from "../../assets/images/gift.jpg";
import { cancelWishReservation, reserveWish } from "../../utils/helper";
import { useFirebaseConnectionContext } from "../../contexts/FirebaseConnectionContext";

const FriendWishComponent = ({ wish }) => {
  const { currentUser } = useFirebaseConnectionContext();
  const [granted, setGranted] = useState(wish.granted);
  const [providerId, setProviderId] = useState(wish.providerId);
  const wishTitle =
    wish.title.length > 20 ? `${wish.title.substr(0, 20)}...` : wish.title
  const handleReservation = (e) => {
    e.preventDefault();
    reserveWish(currentUser.user.uid, wish.id);
    setGranted(true);
    setProviderId(currentUser.user.uid);
  };

  const handleCancelReservation = (e) => {
    e.preventDefault();
    cancelWishReservation(wish.id);
    setGranted(false);
    setProviderId("");
  };

  return (
    <>
      <div className="wishCard">
        <img
          className="w-16 h-16 m-3 rounded-full mx-auto"
          src={wish.image ? wish.image : gift}
          alt="gift"
        />
        <div className="flex flex-col ">
          <h3 className="text-darkOrange text-center font-bold text-2xl">
            {wishTitle}
          </h3>
          <div className="text-darkRed flex items-center h-5/6">
            <div className="flex flex-col gap-6 font-semibold overflow-hidden h-full w-full ">
              <p>
                <span className="font-bold">Prix :</span>{" "}
                <span>{wish.price}€</span>
              </p>
              <p className="text-ellipsis overflow-hidden whitespace-wrap">
                <a
                  className="hover:underline transition ease-in-out delay-150"
                  href={wish.url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {wish.url.substr(0, 30) ?? ""}
                </a>
              </p>
              <div className="flex flex-col items-center mt-3">
                {granted && providerId === currentUser.user.uid ? (
                  <>
                    <p className="text-center italic bg-darkYellow h-full">
                      Vous avez réservé ce souhait
                    </p>
                    <button
                      className="friendsButtonStyle mx-8 max-w-xs gradient"
                      onClick={handleCancelReservation}
                    >
                      Annuler
                    </button>
                  </>
                ) : (
                  ""
                )}
                {granted && providerId !== currentUser.user.uid ? (
                  <p className="text-center italic bg-darkYellow w-fit">
                    Déjà reservé
                  </p>
                ) : (
                  ""
                )}
                {granted === false ? (
                  <button
                    className="friendsButtonStyle mx-8 max-w-xs gradient"
                    onClick={handleReservation}
                  >
                    Réserver
                  </button>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FriendWishComponent;
